/* 開発環境設定 */
export const environment = {
  production: false,

  // (正式ドメイン)
  apiURL: 'https://coopdeli.api.dev.peace-for-coop.com/N_PEACE/',
  imageURL: '',
  version: '0.0.1',

  // 現行バックエンドに秘密裏にログイン
  loginToCurrentBackend: false,

  // 機能メニュー自動クローズ
  fmenuAutoClose: true
};